
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/account_information/404'
  },
  {
    // 首頁
    path: '/',
    name: 'homePage',
    component: () => import('../views/homePage'),
  },
  {
    // 搜尋元件
    path: '/search_component',
    name: 'searchComponent',
    component: () => import('../views/searchComponent')
  },
  {
    // 匯入元件
    path: '/export_list',
    name: 'exportList',
    component: () => import('../views/exportList'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
  {
    // 常用元件
    path: '/commonly_used_components',
    name: 'commonlyUsedComponents',
    component: () => import('../views/commonlyUsedComponents'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
  {
    // 我的元件
    path: '/my_component',
    name: 'myComponent',
    component: () => import('../views/myComponent'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
  {
    // 編輯元件
    path: '/edit_component',
    name: 'editComponent',
    component: () => import('../views/editComponent'),
    meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
  },
  {
    // layout
    path: '/about_user',
    name: 'aboutUser',
    component: () => import('../views/layout'),
    redirect: '/about_user/my_component',
    children: [
      {
        // 許願
        path: 'make_a_wish',
        name: 'makeAWish',
        component: () => import('../views/makeAWish'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
      {
        // 進度查詢
        path: 'track_progress',
        name: 'trackProgress',
        component: () => import('../views/trackProgress'),
        meta: { requiresAuth: true, logOutlogOutStatusCannotEnter: true }
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
